export type PaymentAttempt = {
	fingerprint: string;
	id: string;
};

export const createPaymentAttemptFingerprint = ( ...parts: unknown[] ) =>
	JSON.stringify( parts );

export const getOrCreatePaymentAttempt = (
	currentAttempt: PaymentAttempt | null,
	fingerprint: string,
	createId: () => string = () => crypto.randomUUID()
): PaymentAttempt =>
	currentAttempt?.fingerprint === fingerprint
		? currentAttempt
		: { fingerprint, id: createId() };
